import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ISaleOrder } from '../../../models/sale-order.interface';
import { SaleOrderService } from '../../../services/sale-order.service';

@Component({
  selector: 'eci-sale-order-consols',
  templateUrl: './sale-order-consols.component.html',
  styleUrls: ['./sale-order-consols.component.scss']
})
export class SaleOrderConsolsComponent implements OnInit {
  @Input() info: ISaleOrder;
  @Input() isCreateMode: boolean = false;

  dataSource: any[] = [];

  displayedColumns: string[] = [
    'soConsolSubType',
    'soConsolType',
    'soBatchConsolType',
    'soConsolNo',
  ];

  constructor(private saleOrderSvc: SaleOrderService) { }

  ngOnInit(): void {
    this.getSaleOrderConsols(this.info.id);
  }

  getSaleOrderConsols(id){
    this.saleOrderSvc.getSaleOrderConsols(id).subscribe((result)=>{
      this.dataSource = result?.shipmentConsol;
    });
  }
}
